import AbstractCalls from "./AbstractCalls";

class FakturoidApiCalls extends AbstractCalls {
  listSubjects(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "fakturoidApi/listSubjects");
    return AbstractCalls.get(cmdUri, body, options);
  }

  createInvoice(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "fakturoidApi/createInvoice");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }
}

export default new FakturoidApiCalls();
